module.exports = __webpack_public_path__ + "static/img/02huanbaodai.05844139.gif";